import React from "react";
import logoNuevo from "../../Assets/_Compound Path_@4x_nuevo.png";
import logoGabi from "../../Assets/GABRIEL PEITEADO_v1.1_cream.png";
import "./Footer.css";

const LINKS = [
  { label: "Inicio",               href: "/" },
  { label: "Sobre mí",             href: "/#about" },
  { label: "Servicios",            href: "/#services" },
  { label: "Consultorio",          href: "/#consultorio" },
  { label: "Contacto",             href: "/#contact" },
  { label: "Turnos",               href: "/calendar" },
  { label: "Tienda online",        href: "https://tienda.bianangelucci.com.ar/", external: true },
  { label: "Privacidad",           href: "/privacidad" },
];

const DefineItLogo = () => (
  <span className="footerDefineIt">
    <svg
      className="footerDefineItMark"
      viewBox="0 0 59.44 46.13"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect y="0" width="4.83" height="46.13" fill="currentColor" />
      <rect y="0" width="11.75" height="5.14" fill="currentColor" />
      <rect y="40.99" width="11.75" height="5.14" fill="currentColor" />
      <rect x="54.61" y="0" width="4.83" height="46.13" fill="currentColor" />
      <rect x="47.69" y="0" width="11.75" height="5.14" fill="currentColor" />
      <rect x="47.69" y="40.99" width="11.75" height="5.14" fill="currentColor" />
      <rect x="9.78" y="18.25" width="39.88" height="9.63" fill="#ff5c2b" />
    </svg>
    <span className="footerDefineItTxt">
      define-it
      <small>studio / sf</small>
    </span>
  </span>
);

const Footer = () => (
  <div className="footer">
    <div className="footerBrand">
      <img src={logoNuevo} alt="Bianca Angelucci" className="footerLogo" width="2992" height="988" />
    </div>

    <nav className="footer2">
      {LINKS.map((l) => (
        <a
          key={l.label}
          href={l.href}
          className="footerLinks"
          {...(l.external ? { target: "_blank", rel: "noreferrer" } : {})}
        >
          {l.label}
        </a>
      ))}
    </nav>

    <p className="footerInfo">
      Lic. Bianca Angelucci · M.P. 1847/1 · Junín 2612, Santa Fe
    </p>

    <div className="footerDev">
      Developed by
      <div className="footerDevLogos">
        <a
          href="https://www.linkedin.com/in/gabrielpeiteado/"
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: "none" }}
        >
          <img src={logoGabi} alt="Gabriel Peiteado" className="logogabi" loading="lazy" width="500" height="500" />
        </a>
        <span className="footerDevSeparator" aria-hidden="true" />
        <a
          href="https://define-it.com.ar"
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: "none" }}
        >
          <DefineItLogo />
        </a>
      </div>
    </div>
  </div>
);

export default Footer;
